<template>
  <v-container class="container--fluid" id="profile-view">
    <v-row v-if="profileData">
      <v-col cols="12" md="5" lg="4">
        <UserBioPanel :user-data='profileData' @updateProfile="getProfile()"></UserBioPanel>
      </v-col>
      <v-col cols="12" md="7" lg="8">
        <Setup2fa @updateProfile="getProfile()" :user.sync="profileData" />

        <UserSettings :role="role" :user-data="profileData" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref } from '@vue/composition-api';
import Setup2fa from '@/views/shared/2fa/Setup2fa.vue';
import store from '@/store';
import UserBioPanel from '@/views/shared/users/UserBioPanel';
import UserSettings from '@/views/shared/users/_partials/UserSettings';

export default {
  components: {
    UserBioPanel,
    UserSettings,
    Setup2fa,
  },
  setup() {
    const profileData = ref(null);
    const role = ref(null);

    const getProfile = () => {
      store.dispatch('profile/profile').then((profile) => {
        profileData.value = profile;
        role.value = profile.role;
      });
    };

    getProfile();

    return {
      getProfile,
      profileData,
      role,
    };
  },
};
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
